import React from 'react';
import MultiPage from './MultiPage';
import EditableText from './EditableText';
import { buildCommentSections } from './commentsSections';

export default function CommentsPage({ data, personName, sectionNumber, title, pageNumber, configKey }) {
  const header = (
    <>
      <h2 className="pdf-section-heading pdf-section-heading--numbered">
        <span className="pdf-section-heading__badge">{sectionNumber}</span>
        <EditableText
          as="span"
          path={`${configKey}.sectionHeading`}
          variant="inline"
          stripInlineWrap
          fallback={title}
        />
      </h2>
      <EditableText
        as="div"
        className="pdf-body-text"
        path={`${configKey}.pageConstants`}
        variant="block"
      />
    </>
  );

  return (
    <MultiPage
      header={header}
      items={buildCommentSections(data, configKey)}
      startPageNumber={pageNumber}
      personName={personName}
      sliceKey={configKey}
      sectionKey={configKey}
    />
  );
}
